<template>
	<input-form action="/json/finish-login" :object-data="user" :unsaveable="true" @loading="$emit('loading', $event)" @submit="setStore" v-slot="props" object-key="user">
		<div class="login-content">
			<div class="profile">
				<lazy-background :src="props.object.image_source.thumb100"></lazy-background>
				<h3>{{ props.object.fullname }}<br/><small>@{{ props.object.username }}</small></h3>
			</div>
			<p>We sent a code to your phone number at {{ props.object.phone_masked }}, please enter it to finish logging in.</p>
			<input-text ref="code-input" prepend-icon="essentials/security/keychain" v-model="props.object.code" label="6 Digit Code" :errors="props.errors.code" autocomplete="off" v-mask="'######'" inputmode="decimal"></input-text>
			<div class="actions">
				<icon-button type="submit" :disabled="props.loading > 0 || loading" icon="essentials/security/padlock-open">Verify</icon-button>
				<a href="#" @click.prevent="resendCode">Resend Code</a>
			</div>
		</div>
	</input-form>
</template>

<script>
	export default {
		props: ['user'],
		data() {
			return {
				loading: false
			};
		},
		watch: {
			loading() {
				this.$emit('loading', this.loading);
			}
		},
		methods: {
			async setStore(user) {
				this.$store.state.user = new User(user);
				await this.$nextTick();
				this.$store.state.updateBodyHeight();
				if(this.$store.state.lastUrl) {
					await this.$navigate(this.$store.state.lastUrl);
				}
			},
			async resendCode() {
				this.loading = true;
				try {
					await this.$post('/json/resend-code', this.user);
				} catch(e) {}
				this.loading = false;
			}
		},
		mounted() {
			this.$refs['code-input'].focus();
		}
	}
</script>